module.exports = __webpack_public_path__ + "b1054daa6ae17a19ebae6e61208888c2.svg";